import React from 'react';
import utils from '../../../services/utils';

import Button from '../Button/Button';

import classes from './ButtonPay.module.scss';

const ButtonPay = ({ itemSelectedText, onClick, value, textButton, itemSelected }) => {
  return (
    <div className={classes['pay-button']}>
      <div className={classes['pay-text']}>
        <div className={classes.total}>
          <span className='bold-20'>Total</span>
          <span className='bold-20'>{utils.moneyFormat(value)}</span>
        </div>
        <span className={`${classes.cont} medium-14`}>{itemSelectedText} </span>
      </div>

      <Button
        custom='primary'
        //Icon={Trash}
        color='purple'
        size='md'
        onClick={onClick}
        enabled={itemSelected}>
        {textButton}
      </Button>
    </div>
  );
};

export default ButtonPay;
